import { logout } from '@sunrise-ui/api-client';
import type { WithResponsive } from '@sunrise-ui/primitives';
import {
  Header,
  HeaderTitle,
  LogoIcon,
  ProgressBar,
  TextLight,
  TextReg,
  useDynamicStyles,
} from '@sunrise-ui/primitives';
import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { OrganizationSetupModalScreen } from './OrganizationSetupModalScreen';

export function ManagerOnboardingModalContent() {
  const styles = useDynamicStyles(createStyles);

  const logoutButton = (
    <TouchableOpacity onPress={logout} style={styles.logoutButton}>
      <TextReg style={styles.logoutText}>Log out</TextReg>
    </TouchableOpacity>
  );

  return (
    <>
      <Header
        headerTitle={
          <View style={styles.headerLogoContainer}>
            <HeaderTitle logo={LogoIcon} />
          </View>
        }
        headerLeft={logoutButton}
      />
      <View style={styles.content}>
        <ProgressBar currentStep={3} totalSteps={3} />
        <TextLight style={styles.headerText}>
          Let&apos;s bring community together
        </TextLight>
        <OrganizationSetupModalScreen />
      </View>
    </>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    content: {
      flex: 1,
      padding: isMobile ? 12 : 24,
      alignItems: 'center',
      gap: isMobile ? 16 : 24,
    },
    headerLogoContainer: {
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 40,
      minWidth: 100,
    },
    headerText: {
      fontSize: isMobile ? 24 : 32,
      textAlign: 'center',
    },
    logoutButton: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: 4.5,
    },
    logoutText: {
      fontSize: 14,
    },
  });
